/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
    GuidIdAndLabel,
    GuidIdAndLabelFromJSON,
    GuidIdAndLabelFromJSONTyped,
    GuidIdAndLabelToJSON,
} from './';

/**
 * 
 * @export
 * @interface BCMBookingIdRemarkRuleFormConfiguration
 */
export interface BCMBookingIdRemarkRuleFormConfiguration {
    /**
     * 
     * @type {Array<BrandAndMarketListItem>}
     * @memberof BCMBookingIdRemarkRuleFormConfiguration
     */
    readonly brandsAndMarkets?: Array<BrandAndMarketListItem> | null;
    /**
     * 
     * @type {Array<GuidIdAndLabel>}
     * @memberof BCMBookingIdRemarkRuleFormConfiguration
     */
    readonly providers?: Array<GuidIdAndLabel> | null;
}

export function BCMBookingIdRemarkRuleFormConfigurationFromJSON(json: any): BCMBookingIdRemarkRuleFormConfiguration {
    return BCMBookingIdRemarkRuleFormConfigurationFromJSONTyped(json, false);
}

export function BCMBookingIdRemarkRuleFormConfigurationFromJSONTyped(json: any, ignoreDiscriminator: boolean): BCMBookingIdRemarkRuleFormConfiguration {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'brandsAndMarkets': !exists(json, 'brandsAndMarkets') ? undefined : (json['brandsAndMarkets'] === null ? null : (json['brandsAndMarkets'] as Array<any>).map(BrandAndMarketListItemFromJSON)),
        'providers': !exists(json, 'providers') ? undefined : (json['providers'] === null ? null : (json['providers'] as Array<any>).map(GuidIdAndLabelFromJSON)),
    };
}

export function BCMBookingIdRemarkRuleFormConfigurationToJSON(value?: BCMBookingIdRemarkRuleFormConfiguration | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
    };
}


